import { Body, Injectable } from '@nestjs/common';
import {resourceOperationEfficiencyDTO} from './dto/resource-operation-efficiency.dto';
import {AllResourceOperationEfficiencyResponseModel, ResourceOperationEfficiencyDto, ResourceOperationEfficiencyResponseModel} from '@gtpl/shared-models/planning'
import {resourceOperationEfficiency} from './resource-operation-efficiency.entity';
import {ResourceOperationEfficiencyAdapter} from './dto/resource-operation-efficiency.adapter';
import { Raw, Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { VariantEfficiencyRequest } from './dto/variant-efficiency-request';
import { ResourceOperationEfficiencyLog } from './resource-op-efficiency-log.entity';
@Injectable()
export class ResourceOperationEfficiencyService {
    constructor(
      @InjectRepository(resourceOperationEfficiency)
      private resourceOperationEfficiencyRepository: Repository<resourceOperationEfficiency>,
      @InjectRepository(ResourceOperationEfficiencyLog)
      private resourceOpEffLogRepo: Repository<ResourceOperationEfficiencyLog>,
      private reourceOperationEfficiencyAdapter: ResourceOperationEfficiencyAdapter,
  ){}
  async getCountryDetailsWithoutRelations(variantCode: string,operation:string,minCount:number,maxCount:number): Promise<resourceOperationEfficiency> {
    
    // tslint:disable-next-line: typedef
    const countriesResponse = await this.resourceOperationEfficiencyRepository.findOne({
      where: {variantCode: Raw(alias => `variant_code = '${variantCode}'`),operation: Raw(alias => `operation = '${operation}'`),minCount: Raw(alias => `min_count = '${minCount}'`),maxCount: Raw(alias => `max_count = '${maxCount}'`)},
    });
    if (countriesResponse) {
      return countriesResponse;
    } else {
      return null;
    }
  }
  async createResouceOperationEfficiency(resourceOperationEfficiencyDTO: resourceOperationEfficiencyDTO[], isUpdate: boolean): Promise<ResourceOperationEfficiencyResponseModel> {
      console.log(resourceOperationEfficiencyDTO);
      try {
        let savedCurrencyDtoData = []
        let existedOperationEfficiencyData
        let savedLog
        // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
        for (const efficiencyRecord of resourceOperationEfficiencyDTO){
          if (!isUpdate) {
            const countriesEntity = await this.getCountryDetailsWithoutRelations(efficiencyRecord.variantCode,efficiencyRecord.operation,efficiencyRecord.minCount,efficiencyRecord.maxCount);
            if (countriesEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Efficiency  already exists for variant and operation');
            }
          }
          else{
             existedOperationEfficiencyData = await this.resourceOperationEfficiencyRepository.findOne({where:{resourceOperationEfficiencyId:efficiencyRecord.resourceOperationEfficiencyId}})
             if(existedOperationEfficiencyData.efficiency != efficiencyRecord.efficiency){
              const resourceOpEffLog = new ResourceOperationEfficiencyLog();
              resourceOpEffLog.oldEfficiency = existedOperationEfficiencyData.efficiency;
              resourceOpEffLog.updatedEfficiency = efficiencyRecord.efficiency;
              resourceOpEffLog.resourceOperationEfficiencyId = efficiencyRecord.resourceOperationEfficiencyId;
              resourceOpEffLog.updatedUser = efficiencyRecord.updatedUser;
               savedLog = await this.resourceOpEffLogRepo.save(resourceOpEffLog)
              // resourceOpEffLog.resourceOpInfo = resourceOperationEfficiencyDTO.resourceOperationEfficiencyId;
            }
          //   const resourceOperationEfficiencyEntity = await this.getCountryDetailsWithoutRelations(resourceOperationEfficiencyDTO.variantCode);
          //   if (resourceOperationEfficiencyEntity) {
          //     if(resourceOperationEfficiencyEntity.variantCode!=resourceOperationEfficiencyDTO.variantCode) {
          //       throw new ErrorResponse(11104, 'Resource efficiency already exists');      
          //   }
          //     return new InformationMessageError(11104, "State already exists");
          //   }
          }

          const convertedResourceOperationEfficiency: resourceOperationEfficiencyDTO = this.reourceOperationEfficiencyAdapter.convertDtoToEntity(efficiencyRecord,isUpdate,existedOperationEfficiencyData);
          const savedCountryEntity: resourceOperationEfficiency = await this.resourceOperationEfficiencyRepository.save(
            convertedResourceOperationEfficiency
          );
          const savedCurrencyDto: resourceOperationEfficiencyDTO = this.reourceOperationEfficiencyAdapter.convertEntityToDto(convertedResourceOperationEfficiency);
          savedCurrencyDtoData.push(savedCurrencyDto);
            // console.log(savedStateDto);
            
        }
        if (savedCurrencyDtoData.length > 0) {
          // generating resposnse
          const response = new ResourceOperationEfficiencyResponseModel(true,1,isUpdate? 'Resource efficiency updated Successfully': 'Resource efficiency Created Successfully')
          return response
        } else {
          // return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
          throw new ErrorResponse(11106,'Resource efficiency saved but issue while transforming into DTO');
        }
      } catch (error) {
        // when error occures while saving the data , the execution will come to catch block.
        // tslint:disable-next-line: typedef
        throw error;
      }

  }
  async getAllResourceOperationEfficiency(): Promise<AllResourceOperationEfficiencyResponseModel> {
    // const page: number = 1;
    
    try {
      const resourceOperationEfficiencyDtos: resourceOperationEfficiencyDTO[] = [];
      //retrieves all companies
      const resourceOperationEfficiencyEntities: resourceOperationEfficiency[] = await this.resourceOperationEfficiencyRepository.find();
      //console.log(statesEntities);
      if (resourceOperationEfficiencyEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        resourceOperationEfficiencyEntities.forEach(ROEfficiencyEntity => {
          const convertedROEDto: resourceOperationEfficiencyDTO = this.reourceOperationEfficiencyAdapter.convertEntityToDto(
            ROEfficiencyEntity
          );
          resourceOperationEfficiencyDtos.push(convertedROEDto);
          // console.log('convertedCountriesDto');
          // console.log(convertedROEDto);
        });
       
        const response = new AllResourceOperationEfficiencyResponseModel(true,1,'resourceOperationEfficiency  retrieved successfully',resourceOperationEfficiencyDtos);
        //generated response
        return response
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    
    } catch (err) {
      throw err;
    }
  }
  async getAllActiveResourceOperationEfficiency(): Promise<AllResourceOperationEfficiencyResponseModel> {
    // const page: number = 1;
    try {
        const countriesDto: resourceOperationEfficiencyDTO[] = [];
        //retrieves all companies
        const CountriesEntities: resourceOperationEfficiency[] = await this.resourceOperationEfficiencyRepository.find({where:{isActive:true},
       });
     console.log(CountriesEntities)
        if (CountriesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            CountriesEntities.forEach(countriesEntity => {
                const convertedcountriesDto: resourceOperationEfficiencyDTO = this.reourceOperationEfficiencyAdapter.convertEntityToDto(
                  countriesEntity
                  
                );
                countriesDto.push(convertedcountriesDto);
            });
            const response = new AllResourceOperationEfficiencyResponseModel(true, 11108, "Countries retrieved successfully");
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found'); 
        }
    } catch (err) {
        throw err;
    }
}

async getEfficiencyByVariant( varientReq:VariantEfficiencyRequest):Promise<AllResourceOperationEfficiencyResponseModel>{
  const Efficiencydata = await this.resourceOperationEfficiencyRepository.find({where:{isActive:true,variantCode:varientReq.variantCode},
  });
  if(Efficiencydata.length > 0){
    let efficiencyDetails:ResourceOperationEfficiencyDto[] = []
    for(const efficiencyRecord of Efficiencydata){
      const obj = new ResourceOperationEfficiencyDto(efficiencyRecord.resourceOperationEfficiencyId,efficiencyRecord.operation,efficiencyRecord.variantCode,efficiencyRecord.efficiency,efficiencyRecord.minCount,efficiencyRecord.maxCount,efficiencyRecord.createdUser,efficiencyRecord.hrsPerShift);
      efficiencyDetails.push(obj);
    }
    return new AllResourceOperationEfficiencyResponseModel(true,55555,'efficiency data retrived successfully',efficiencyDetails);
  }else{
    return new AllResourceOperationEfficiencyResponseModel(false,99999,'No data found',undefined);
  }
}
//   async activateOrDeactivateCountry(countryReq: CountryRequest): Promise<CountriesResponseModel> {
//     try {
//         const countryExists = await this.getCountryById(countryReq.countryId);
//         if (countryExists) {
//             if (countryReq.versionFlag !== countryExists.versionFlag) {
//                 throw new ErrorResponse(10113, 'Someone updated the current country information.Refresh and try again');
//             } else {
                
//                     const countryStatus =  await this.countriesRepository.update(
//                         { countryId: countryReq.countryId },
//                         { isActive: countryReq.isActive,updatedUser: countryReq.updatedUser });
                   
//                     if (countryExists.isActive) {
//                         if (countryStatus.affected) {
//                             const countryResponse: CountriesResponseModel = new CountriesResponseModel(true, 10115, 'Country is de-activated successfully');
//                             return countryResponse;
//                         } else {
//                             throw new ErrorResponse(10111, 'Country is already deactivated');
//                         }
//                     } else {
//                         if (countryStatus.affected) {
//                             const CountryResponse: CountriesResponseModel = new CountriesResponseModel(true, 10114, 'Country is activated successfully');
//                             return CountryResponse;
//                         } else {
//                             throw new ErrorResponse(10112, 'Country is already  activated');
//                         }
//                     }
//                 // }
//             }
//         } else {
//             throw new ErrorResponse(99998, 'No Records Found');
//         }
//     } catch (err) {
//         throw err;
//     }
// }
}
